import { render } from "./Painter.vue?vue&type=template&id=27ad92c8&scoped=true"
import script from "./Painter.vue?vue&type=script&lang=js"
export * from "./Painter.vue?vue&type=script&lang=js"

import "./Painter.vue?vue&type=style&index=0&id=27ad92c8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ad92c8"]])

export default __exports__